import React, { createContext, useContext, useState } from "react";

interface AuthType {
  token: string | null;
  role: string | null;
  userId: string | null;
  name: string | null;
  email: string | null;
  phoneNumber: string | null;
  gender: string | null;
  login: (
    token: string,
    role: string,
    userId: string,
    name: string,
    email: string,
    phoneNumber: string,
    gender: string
  ) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [token, setToken] = useState<string | null>(sessionStorage.getItem("token"));
  const [role, setRole] = useState<string | null>(sessionStorage.getItem("role"));
  const [userId, setUserId] = useState<string | null>(sessionStorage.getItem("userId"));
  const [name, setName] = useState<string | null>(sessionStorage.getItem("name"));
  const [email, setEmail] = useState<string | null>(sessionStorage.getItem("email"));
  const [phoneNumber, setPhoneNumber] = useState<string | null>(sessionStorage.getItem("phoneNumber"));
  const [gender, setGender] = useState<string | null>(sessionStorage.getItem("gender"));

  const login = (
    token: string,
    role: string,
    userId: string,
    name: string,
    email: string,
    phoneNumber: string,
    gender: string
  ) => {
    setToken(token);
    setRole(role);
    setUserId(userId);
    setName(name);
    setEmail(email);
    setPhoneNumber(phoneNumber);
    setGender(gender);

    sessionStorage.setItem("token", token);
    sessionStorage.setItem("role", role);
    sessionStorage.setItem("userId", userId);
    sessionStorage.setItem("name", name);
    sessionStorage.setItem("email", email);
    sessionStorage.setItem("phoneNumber", phoneNumber);
    sessionStorage.setItem("gender", gender);
  };

  const logout = () => {
    setToken(null);
    setRole(null);
    setUserId(null);
    setName(null);
    setEmail(null);
    setPhoneNumber(null);
    setGender(null);

    sessionStorage.clear();
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        role,
        userId,
        name,
        email,
        phoneNumber,
        gender,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};
